<script>
import PreChatForm from './components/PreChatForm.vue';

export default {
  name: 'App',
  components: {
    PreChatForm,
  },
  data() {
    return {
      businessColor: window.preChatConfigs.businessColor || '#1f93ff',
    };
  },
};
</script>

<template>
  <div
    dir="ltr"
    class="app-background flex items-center justify-center min-h-screen overflow-auto p-4"
  >
    <div class="max-w-md w-full bg-white rounded-2xl shadow-lg overflow-hidden">
      <PreChatForm />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.app-background {
  background: v-bind(businessColor);
}
</style>

<style lang="scss">
@import './assets/scss/index.scss';
</style>
